import { v4 as uuid } from 'uuid';
import { Identifier } from './identifier';

export class UniqueEntityID extends Identifier<number | string> {
  public constructor(id?: number | string) {
    super(id ?? uuid());
  }
}
